import { CONTENT_TYPE } from "@/src/components/content/Type";

export function contentFiltersToApi(
  filters: Record<string, string>,
  contentType: string,
): Record<string, unknown> {
  const statusFilter = filters.pub_status;
  const contentTypeFilter = filters.content_type;
  const restrictionFilter = filters.restrictions;

  const baseType: string | string[] =
    contentType === CONTENT_TYPE.HOSTED
      ? [CONTENT_TYPE.HOSTED, CONTENT_TYPE.MASTER]
      : contentType;

  const filter: Record<string, unknown> = {
    status: statusFilter ?? "not_archived",
    type: baseType,
  };

  switch (contentTypeFilter) {
    case "video":
      filter.type = CONTENT_TYPE.HOSTED;
      filter.audio_only = false;
      break;
    case "replay":
      filter.type = CONTENT_TYPE.HOSTED;
      filter.replay = true;
      break;
    case "audio":
      filter.type = CONTENT_TYPE.HOSTED;
      filter.audio_only = true;
      break;
    case "master":
      filter.type = CONTENT_TYPE.MASTER;
      break;
    default:
      break;
  }

  if (restrictionFilter) {
    filter[restrictionFilter] = true;
  }

  return filter;
}
